export function isWebkit() {
	return (
		typeof navigator !== 'undefined' &&
		/AppleWebKit/.test(navigator.userAgent) &&
		!/(Chrome|Chromium|Edg)/.test(navigator.userAgent)
	);
}
